import { render } from "./modal-section.vue?vue&type=template&id=b2c88d36&scoped=true"
import script from "./modal-section.vue?vue&type=script&lang=js"
export * from "./modal-section.vue?vue&type=script&lang=js"

import "./modal-section.vue?vue&type=style&index=0&id=b2c88d36&lang=stylus&scoped=true"

import exportComponent from "/var/www/docker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2c88d36"],['__file',"src/components/modal-section.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b2c88d36"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b2c88d36', __exports__)) {
    api.reload('b2c88d36', __exports__)
  }
  
  module.hot.accept("./modal-section.vue?vue&type=template&id=b2c88d36&scoped=true", () => {
    api.rerender('b2c88d36', render)
  })

}


export default __exports__